// The Spraytan Queen — B2B signup form
// Calls the Cloudflare Worker (CVR lookup + Shopify customer creation).

(function () {
  const form = document.getElementById('b2bSignupForm');
  if (!form) return;

  const workerUrl = form.dataset.workerUrl;
  const cvrInput = document.getElementById('b2b-cvr');
  const cvrResult = document.getElementById('b2bCvrResult');
  const errorBox = document.getElementById('b2bSignupError');
  const submitBtn = document.getElementById('b2bSubmitBtn');
  const successBox = document.getElementById('b2bSignupSuccess');

  let lookupTimer = null;

  function showCvrResult(text, isError) {
    cvrResult.textContent = text;
    cvrResult.classList.toggle('is-error', !!isError);
    cvrResult.classList.toggle('is-ok', !isError && !!text);
  }

  cvrInput.addEventListener('input', () => {
    const cvr = cvrInput.value.trim();
    showCvrResult('', false);
    clearTimeout(lookupTimer);

    if (!/^\d{8}$/.test(cvr)) return;

    lookupTimer = setTimeout(async () => {
      showCvrResult('Slår CVR-nummer op…', false);
      try {
        const res = await fetch(`${workerUrl}/cvr-lookup?vat=${cvr}`);
        const data = await res.json();
        if (!res.ok) {
          showCvrResult(data.error || 'Kunne ikke finde CVR-nummeret.', true);
          return;
        }
        showCvrResult(`${data.name} — ${data.address}, ${data.zipcode} ${data.city}`, false);
      } catch (err) {
        showCvrResult('Kunne ikke slå CVR-nummeret op lige nu.', true);
      }
    }, 500);
  });

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    errorBox.textContent = '';

    const email = document.getElementById('b2b-email').value.trim();
    const phone = document.getElementById('b2b-phone').value.trim();
    const cvr = cvrInput.value.trim();

    if (!/^\d{8}$/.test(cvr)) {
      errorBox.textContent = 'Indtast et gyldigt 8-cifret CVR-nummer.';
      return;
    }

    submitBtn.disabled = true;
    submitBtn.textContent = 'Sender…';

    try {
      const res = await fetch(`${workerUrl}/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, phone, cvr }),
      });
      const data = await res.json();

      if (!res.ok) {
        errorBox.textContent = data.error || 'Noget gik galt. Prøv igen.';
        submitBtn.disabled = false;
        submitBtn.textContent = form.dataset.submitLabel || 'Send ansøgning';
        return;
      }

      form.style.display = 'none';
      successBox.classList.add('visible');
    } catch (err) {
      errorBox.textContent = 'Kunne ikke sende ansøgningen lige nu. Prøv igen om lidt.';
      submitBtn.disabled = false;
      submitBtn.textContent = form.dataset.submitLabel || 'Send ansøgning';
    }
  });
})();
